// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar-module__ui-ProgressBar--aKsvc {
  --progress-bar-track-color: var(--chaek-color-surface-progress-track-detail);
  --progress-bar-indicator-color: #1a1a1a;

  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
}

.ProgressBar-module__box--C9HSw {
  width: 100%;
  height: 4px;
  overflow: hidden;
  border-radius: 4px;
  background-color: var(--progress-bar-track-color);
}

.ProgressBar-module__bar--j7RCe {
  width: 2px;
  height: 100%;
  background-color: var(--progress-bar-indicator-color);
}

.ProgressBar-module__variant-default--zMI72 {
  --progress-bar-track-color: var(--chaek-color-surface-progress-track-detail);
  --progress-bar-indicator-color: #1a1a1a;
}

.ProgressBar-module__variant-accent--ACnVc {
  --progress-bar-track-color: var(--chaek-color-surface-progress-track);
  --progress-bar-indicator-color: var(--chaek-color-surface-accent);
}

.ProgressBar-module__variant-subtle--BDfcl {
  --progress-bar-track-color: var(--chaek-color-surface-progress-track);
  --progress-bar-indicator-color: #b1b1b7;
}

.ProgressBar-module__header--URP5U {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
}

.ProgressBar-module__header--URP5U:has(.ProgressBar-module__title--uyFhC) {
  order: -1;
  justify-content: space-between;
}

.ProgressBar-module__ui-ProgressBar--aKsvc:has(.ProgressBar-module__title--uyFhC) {
  gap: 8px;
}

.ProgressBar-module__ui-ProgressBar--aKsvc:has(.ProgressBar-module__title--uyFhC) .ProgressBar-module__box--C9HSw {
  height: 6px;
}

.ProgressBar-module__title--uyFhC {
  padding-bottom: 2px;
  color: var(--chaek-color-text-primary-detail);
  font-size: 1rem; /* 16px */
  font-weight: 600;
  line-height: 1.1429;
}

.ProgressBar-module__label--kemc4 {
  display: block;
  padding-bottom: 1px;
  color: #666;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  word-break: break-word;
  text-align: right;
}

.ProgressBar-module__size-large--yJ7ee .ProgressBar-module__label--kemc4 {
  color: var(--chaek-color-text-muted);
  font-size: 0.6875rem; /* 11px */
  letter-spacing: 0.064453125px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/ProgressBar/ProgressBar.module.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,uCAAuC;;EAEvC,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,4EAA4E;EAC5E,uCAAuC;AACzC;;AAEA;EACE,qEAAqE;EACrE,iEAAiE;AACnE;;AAEA;EACE,qEAAqE;EACrE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB,EAAE,SAAS;EAC/B,6BAA6B;AAC/B","sourcesContent":[".ui-ProgressBar {\n  --progress-bar-track-color: var(--chaek-color-surface-progress-track-detail);\n  --progress-bar-indicator-color: #1a1a1a;\n\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.box {\n  width: 100%;\n  height: 4px;\n  overflow: hidden;\n  border-radius: 4px;\n  background-color: var(--progress-bar-track-color);\n}\n\n.bar {\n  width: 2px;\n  height: 100%;\n  background-color: var(--progress-bar-indicator-color);\n}\n\n.variant-default {\n  --progress-bar-track-color: var(--chaek-color-surface-progress-track-detail);\n  --progress-bar-indicator-color: #1a1a1a;\n}\n\n.variant-accent {\n  --progress-bar-track-color: var(--chaek-color-surface-progress-track);\n  --progress-bar-indicator-color: var(--chaek-color-surface-accent);\n}\n\n.variant-subtle {\n  --progress-bar-track-color: var(--chaek-color-surface-progress-track);\n  --progress-bar-indicator-color: #b1b1b7;\n}\n\n.header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.header:has(.title) {\n  order: -1;\n  justify-content: space-between;\n}\n\n.ui-ProgressBar:has(.title) {\n  gap: 8px;\n}\n\n.ui-ProgressBar:has(.title) .box {\n  height: 6px;\n}\n\n.title {\n  padding-bottom: 2px;\n  color: var(--chaek-color-text-primary-detail);\n  font-size: 1rem; /* 16px */\n  font-weight: 600;\n  line-height: 1.1429;\n}\n\n.label {\n  display: block;\n  padding-bottom: 1px;\n  color: #666;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: normal;\n  white-space: nowrap;\n  word-break: break-word;\n  text-align: right;\n}\n\n.size-large .label {\n  color: var(--chaek-color-text-muted);\n  font-size: 0.6875rem; /* 11px */\n  letter-spacing: 0.064453125px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-ProgressBar": `ProgressBar-module__ui-ProgressBar--aKsvc`,
	"box": `ProgressBar-module__box--C9HSw`,
	"bar": `ProgressBar-module__bar--j7RCe`,
	"variant-default": `ProgressBar-module__variant-default--zMI72`,
	"variant-accent": `ProgressBar-module__variant-accent--ACnVc`,
	"variant-subtle": `ProgressBar-module__variant-subtle--BDfcl`,
	"header": `ProgressBar-module__header--URP5U`,
	"title": `ProgressBar-module__title--uyFhC`,
	"label": `ProgressBar-module__label--kemc4`,
	"size-large": `ProgressBar-module__size-large--yJ7ee`
};
export default ___CSS_LOADER_EXPORT___;
